import { render, staticRenderFns } from "./single-file-upload.vue?vue&type=template&id=3c22fde8"
import script from "./single-file-upload.vue?vue&type=script&lang=js"
export * from "./single-file-upload.vue?vue&type=script&lang=js"
import style0 from "./single-file-upload.vue?vue&type=style&index=0&id=3c22fde8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports